import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";

const PlansDropdown = ({ row, setCurrentPlan }) => {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const buttonRef = useRef(null);
    const menuRef = useRef(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });

    const handleToggle = () => {
        if (!isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setPosition({
                top: rect.bottom + 10,
                left: rect.right - 120,
            });
        }
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                buttonRef.current &&
                menuRef.current &&
                !buttonRef.current.contains(event.target) &&
                !menuRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        const handleScroll = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            window.addEventListener("scroll", handleScroll, true);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("scroll", handleScroll, true);
        };
    }, [isOpen]);

    return (
        <>
            <div className="dropdown">
                <button
                    type="button"
                    className="link dropdown-toggle"
                    aria-expanded="false"
                    onClick={handleToggle}
                    ref={buttonRef}
                    title="Plans"
                >
                    <em className="icon ni ni-info"></em>
                </button>
                {isOpen &&
                    createPortal(
                        <ul
                            className="position-fixed dropdown-menu dropdown-menu-end show"
                            style={{
                                maxHeight: "200px",
                                top: `${position.top}px`,
                                left: `${position.left}px`,
                                overflowY: "auto",
                            }}
                            ref={menuRef}
                        >
                            {row?.plans?.map((p) => (
                                <li key={p?.daily_plan}>
                                    <div
                                        className="dropdown-item"
                                        data-bs-toggle="modal"
                                        data-bs-target={`#machine-details-plan`}
                                        onClick={() => {
                                            setCurrentPlan(p);
                                        }}
                                    >
                                        <p className="mb-0 pb-0">
                                            {`${p?.work_order} : ${p?.daily_plan}`}
                                        </p>
                                        <p className="mt-0 pt-0">
                                            {`Manual Count: ${p?.manual_production_count}`}
                                        </p>
                                    </div>
                                </li>
                            ))}
                        </ul>,
                        document.body
                    )}
            </div>
        </>
    );
};

export default PlansDropdown;
